import type { StorefrontEmbedAuditDto } from "@babackapp/private-api-client/generated/schema";
import { isReadyToClean } from "./storefront-embed-summary";

export const ALL_STATUSES = "all";

export type EmbedShop = {
  id: string;
  name: string;
  shopifyUrl: string;
  isTestShop: boolean;
  isActive: boolean;
};

export type EmbedFilters = {
  search: string;
  status: string;
  readyOnly: boolean;
  includeTest: boolean;
  includeInactive: boolean;
};

export const DEFAULT_FILTERS: EmbedFilters = {
  search: "",
  status: ALL_STATUSES,
  readyOnly: false,
  includeTest: false,
  includeInactive: false,
};

export type EmbedRow = {
  shop: EmbedShop;
  audit: StorefrontEmbedAuditDto | undefined;
};

// Applied before fetching, so excluded shops cost no request.
export const isInScope = (shop: EmbedShop, filters: EmbedFilters): boolean =>
  shop.shopifyUrl.trim() !== "" &&
  (filters.includeTest || !shop.isTestShop) &&
  (filters.includeInactive || shop.isActive);

const matchesSearch = (shop: EmbedShop, search: string): boolean => {
  const needle = search.trim().toLowerCase();
  return (
    shop.name.toLowerCase().includes(needle) ||
    shop.shopifyUrl.toLowerCase().includes(needle)
  );
};

// A shop whose audit is not loaded yet never matches an audit-based filter.
export const matchesFilters = (
  { shop, audit }: EmbedRow,
  filters: EmbedFilters,
): boolean =>
  isInScope(shop, filters) &&
  matchesSearch(shop, filters.search) &&
  (filters.status === ALL_STATUSES || audit?.embedStatus === filters.status) &&
  (!filters.readyOnly || (audit !== undefined && isReadyToClean(audit)));
